module.exports = __webpack_public_path__ + "media/images/radio-button-checked-195e9e3a86007be4e7eb44c5433500a6.svg";